/* eslint-disable @ngrx/prefix-selectors-with-select */
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPatientFamilyHistories from '../reducer/patient-family-history.reducer';

export const patientFamilyHistoriesFeatureSelector =
  createFeatureSelector<fromPatientFamilyHistories.PatientFamilyHistoriesState>(
    fromPatientFamilyHistories.patientFamilyHistoriesFeatureKey
  );

const { selectEntities, selectAll } = fromPatientFamilyHistories.patientFamilyHistoriesAdapter.getSelectors();

export const selectPatientFamilyHistoryEntities = createSelector(patientFamilyHistoriesFeatureSelector, selectEntities);

export const selectPatientFamilyHistories = createSelector(patientFamilyHistoriesFeatureSelector, selectAll);

export const selectCurrentCount = createSelector(
  selectPatientFamilyHistories,
  patientFamilyHistories => patientFamilyHistories?.length ?? 0
);

export const selectError = createSelector(
  patientFamilyHistoriesFeatureSelector,
  state => state?.baseState?.error ?? null
);

export const selectIsLoading = createSelector(
  patientFamilyHistoriesFeatureSelector,
  state => state?.baseState?.isLoading ?? false
);

export const selectPageNumber = createSelector(
  patientFamilyHistoriesFeatureSelector,
  state => state?.baseState?.pageNumber ?? 0
);

export const selectPageSize = createSelector(patientFamilyHistoriesFeatureSelector, state => state.pageSize);

export const selectIsAtEndOfData = createSelector(
  patientFamilyHistoriesFeatureSelector,
  state => state?.baseState?.isAtEndOfData ?? false
);

export const selectTotalRecordCount = createSelector(
  patientFamilyHistoriesFeatureSelector,
  state => state?.baseState?.totalRecordCount ?? 0
);

export const selectIsFullDatasetLoaded = createSelector(
  patientFamilyHistoriesFeatureSelector,
  state => state?.isFullDatasetLoaded ?? false
);

export const selectCachePatientId = createSelector(
  patientFamilyHistoriesFeatureSelector,
  state => state?.cachePatientId ?? null
);

export const selectCacheLoadedAt = createSelector(
  patientFamilyHistoriesFeatureSelector,
  state => state?.cacheLoadedAt ?? null
);

export const selectIsFullDatasetLoading = createSelector(
  patientFamilyHistoriesFeatureSelector,
  state => state?.isFullDatasetLoading ?? false
);

export const selectFullDatasetError = createSelector(
  patientFamilyHistoriesFeatureSelector,
  state => state?.fullDatasetError ?? null
);
